import { render, staticRenderFns } from "./InputFieldWithPrefix.vue?vue&type=template&id=23436228&"
import script from "./InputFieldWithPrefix.vue?vue&type=script&lang=js&"
export * from "./InputFieldWithPrefix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports